import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {Popover} from 'antd'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import SignalField from '../Signal'
import TradeSelect from '../TradeSelect'
import {Divider} from 'antd'

const popover = (<div>Add the signal to close your positions</div>)

import style from './fields.sass'

@inject('store') @observer
class Additional extends Component {
  handleChange = (name, value) => {
    this.props.store.algo.single.change(name, value)
  }
  render() {
    const {data, errors} = this.props.store.algo.single
    const hasCoin = this.props.hasCoin
    return(
      <div styleName='wrapper'>
        <Divider styleName='divider'/>
        <div styleName='signal-container'>
          <label htmlFor='signal'>Cover signal:</label>
          <Popover
            content={popover}
            placement='right'
            styleName='popover'
          >
            <span>
              <FontAwesomeIcon icon='question-circle'/>
            </span>
          </Popover>
          <SignalField
            name='additional_signal'
            required={false}
            has_coin={hasCoin}
          />
          <p styleName='error' dangerouslySetInnerHTML={{__html:errors.additional_signal}}/>
        </div>
        <div styleName='trade'>
          <label>Cover trade:*</label>
          <TradeSelect
            name='cover_trade_type'
            label='Trade'
            type='cover_trade'
            value={data.cover_trade_type}
            tradeValue={data.cover_trade_value}
            hasCoin={hasCoin}
            changeHandler={this.handleChange}
            placeholder='Select cover trade type'
          />
        </div>
      </div>
    )
  }
}

export default Additional
